<div class="block-container" fxLayout="column" fxLayoutGap="12px">
	<ahs-text
		#ref
		id="newStartDate"
		[required]="true"
		[customValidationMessages]="customValidationMessages"
		tabOrder="1"
		[ahsFormGroup]="formGroup"
		appearance="outline"
		[required]="true"
		(tabKeyPressed)="markAllFieldsAsTouched()"
		(valueChanged)="markAllFieldsAsTouched()"
		(blur)="markAllFieldsAsTouched()"
	></ahs-text>
</div>
